import React, { PureComponent, PropTypes } from 'react';
import { EventLocalDate, EventLocation, EventName, EventScheduled } from '../event';
import RecruitList from '../RecruitList';
import UserList from '../UserList';
import { commonPropTypes, dateFormats, eventTypes } from '../../util/constants';
import { extractFlaggingUsers, extractScheduled } from '../../util/EventUtil';
import moment from 'moment';
import cx from 'classnames';

const { RECRUIT_APPOINTMENT, SCHOOL_GAME } = eventTypes;
const LABEL_COLOR = 'color-light-gray';
const LABEL_CLASSES = cx(LABEL_COLOR, 'mg-top-md');

export default class EventDetails extends PureComponent {

  static propTypes = {
    event: commonPropTypes.EVENT_SHAPE
  };

  static defaultProps = {
    event: {}
  };

  render() {
    const { className, event } = this.props;
    const eventDate = moment(extractScheduled(event)).format(dateFormats.DISPLAY_DATE);

    return (
      <div className={cx('color-text', className)}>
        <div>
          <strong>
            <label className={cx(LABEL_COLOR, 'mg-top-none')}>
              Event Name
            </label>
          </strong>
        </div>
        <div><EventName event={event} wrap/></div>

        <div><strong><label className={LABEL_CLASSES}>When</label></strong></div>
        <div>
          <span><EventLocalDate event={event} format={dateFormats.DISPLAY_DATE}/></span>
          <EventScheduled className="mg-left-sm" event={event} showRange={true}/>
        </div>

        <div><strong><label className={LABEL_CLASSES}>Location</label></strong></div>
        <div>
          <EventLocation event={event}/>
        </div>

        <div><strong><label className={LABEL_CLASSES}>Recruits</label></strong></div>
        <div>
          <RecruitList recruits={event.recruits}/>
        </div>

        <div><strong><label className={LABEL_CLASSES}>Attendees</label></strong></div>
        <div>
          <UserList users={extractFlaggingUsers(event)}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/event/EventDetails.jsx